/* @flow */
import React, { Component } from 'react';
import Item from './item.js';

class ImpressionsList extends Component {

  constructor(props) {
    super(props);
    const listItems = this.props.impressions.reduce((acc, i) => {
      acc[i.itemId] = (
        <li key={i.itemId}>
          <Item itemId={i.itemId}
                impressionCount={i.impressionCount}
                viewCount={i.viewCount}
                linkHref="#"
                imageSrc="#" />
        </li>
      );
      return acc;
    }, {});
    this.state = { listItems: listItems };
    this.getItemData();
  }

  getItemData() {
    const listItems = Object.assign({}, this.state.listItems);
    const client = this.props.httpClient;
    const endpoints = this.props.endpoints;
    client.get(endpoints.itemData(Object.keys(listItems)))
      .then((response) => {
        response.data.forEach((doc) => {
          const itemId = doc['item_id'];
          const url = doc['url'];
          const src = doc['src'];
          const listItem = listItems[itemId.toString()];
          if (listItem) {
            const impressionCount = listItem.props.children.props.impressionCount;
            const viewCount = listItem.props.children.props.viewCount;
            listItems[itemId.toString()] = (
              <li key={itemId}>
                <Item itemId={itemId}
                      impressionCount={impressionCount}
                      viewCount={viewCount}
                      linkHref={url}
                      imageSrc={src} />
              </li>
            );
          }
        });
        this.setState({ listItems: listItems });
      })
      .catch((error) => {
        console.log('Error in ImpressionsList.getItemData(...):', error);
      })
    ;
  }

  render() {
    const orderedItems = this.props.impressions.map(i => this.state.listItems[i.itemId.toString()]);
    return (
      <section className="TabbedList impressions">
        <ul>
          {orderedItems}
        </ul>
      </section>
    );
  }

}

export default ImpressionsList;



// WEBPACK FOOTER //
// ./src/app/stats/container/impressions-and-views/impressions-list.js